import {
  NumericFormat as NumberFormat,
  NumericFormatProps as NumberFormatProps,
} from 'react-number-format';

type MoneyFormatProps = Pick<NumberFormatProps, 'value'>;

export default function MoneyFormat(props: MoneyFormatProps) {
  return (
    <NumberFormat
      {...props}
      displayType='text'
      thousandSeparator={true}
      prefix='$'
    />
  );
}
